import React from "react";
import ProgramDetailsSection from "../../../../components/template/ProgramDetailSection";

const InPower = () => {
  return (
    <ProgramDetailsSection
      title="INPOWER"
      tagline="Self-Leadership Workshop"
      highlights={[
        "Purpose-driven leadership",
        "Ownership mindset",
        "Intrinsic motivation",
      ]}
      description="INPOWER empowers individuals to become effective self-leaders by cultivating purpose, ownership, motivation, and communication skills that create lasting personal and professional impact."
      duration="1.5 Days"
      focusAreas={[
        "Self-Leadership",
        "Intrinsic Motivation",
        "Ownership Mindset",
        "Purpose & Values Alignment",
        "Communication & Influence",
      ]}
      outcomes={[
        "Lead with greater self-awareness, confidence, and accountability.",
        "Discover deeper sources of motivation beyond targets and incentives.",
        "Align personal purpose with professional growth and leadership impact.",
      ]}
      images={[
         "../../../cw/CW6.JPG",
          "../../../cw/CW7.JPG",
           "../../../cw/CW8.JPG"
      ]}
    />
  );
};

export default InPower;